export const formattedMeasureUnits = {
  unit: { single: 'ctx.discount.measure-units.unit', plural: 'ctx.discount.measure-units.units' },
  t: { single: 'ctx.discount.measure-units.ton', plural: 'ctx.discount.measure-units.ton' },
  kg: { single: 'ctx.discount.measure-units.kg', plural: 'ctx.discount.measure-units.kg' },
  q: { single: 'ctx.discount.measure-units.quintal', plural: 'ctx.discount.measure-units.quintal' },
  l: { single: 'ctx.discount.measure-units.liter', plural: 'ctx.discount.measure-units.liter' },
  piece: { single: 'ctx.discount.measure-units.piece', plural: 'ctx.discount.measure-units.pieces' },
  ml: { single: 'ctx.discount.measure-units.milliliter', plural: 'ctx.discount.measure-units.milliliter' },
  linear_meter: {
    single: 'ctx.discount.measure-units.linear-meter',
    plural: 'ctx.discount.measure-units.linear-meter',
  },
  ha: { single: 'ctx.discount.measure-units.hectare', plural: 'ctx.discount.measure-units.hectare' },
  lb: { single: 'ctx.discount.measure-units.pound', plural: 'ctx.discount.measure-units.pound' },
  oz: { single: 'ctx.discount.measure-units.ounce', plural: 'ctx.discount.measure-units.ounce' },
  gal: { single: 'ctx.discount.measure-units.gallon', plural: 'ctx.discount.measure-units.gallon' },
  any: { single: 'ctx.discount.measure-units.any', plural: 'ctx.discount.measure-units.any' },
}
